<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="container">
      <!-- 头部图 -->
      <div class="banner-box">
        <div class="banner-con">
          <div class="banner-title">是客户，也是伙伴</div>
          <div class="banner-desc">
            深耕信息化20余年，轻骑兵助力千行百业成功交付万余应用
          </div>
        </div>
        <!-- 动画 -->
        <div class="customerComments">
          <div class="developmentExperience customerCommentsStyle showOrHide1">
            <div>
              <img src="../assets/img/casePage/people.png" />
              可视化开发体验非常好，领先全行业
            </div>
          </div>
          <div class="poc customerCommentsStyle showOrHide2">
            <div>
              <img src="../assets/img/casePage/people.png" />
              POC验证优势明显
            </div>
          </div>
          <div class="technicalRoutes customerCommentsStyle showOrHide3">
            <div>
              <img src="../assets/img/casePage/people.png" />
              统一了技术路线
            </div>
          </div>
          <div class="safe customerCommentsStyle showOrHide4">
            <div>
              <img src="../assets/img/casePage/people.png" />
              资质很全，安全性有保障
            </div>
          </div>
          <!-- <div class="expansion customerCommentsStyle showOrHide5">
            <div>
              <img src="../assets/img/casePage/people.png">
              最看重二次开发拓展能力
            </div>
          </div> -->
          <div class="service customerCommentsStyle showOrHide6">
            <div>
              <img src="../assets/img/casePage/people.png" />
              一对多服务，效率非常高
            </div>
          </div>
          <!-- <div class="reversible customerCommentsStyle showOrHide7">
            <div>
              <img src="../assets/img/casePage/people.png">
              被高还原性打动
            </div>
          </div> -->
          <div class="costSave customerCommentsStyle showOrHide8">
            <div>
              <img src="../assets/img/casePage/people.png" />
              节省了上百万成本
            </div>
          </div>
          <div class="nationalInternet customerCommentsStyle showOrHide9">
            <div>
              <img src="../assets/img/casePage/people.png" />
              完全满足国产信创的需求
            </div>
          </div>
        </div>
      </div>
      <!-- 典型案例 -->
      <div class="case-box">
        <div class="case-title">典型案例</div>
        <div class="case-list">
          <div class="case-item" v-for="item in article" :key="item.id">
            <router-link
              :to="{
                path: '/CasePhonePage/CasePhonePageArticle',
                query: { id: item.id },
              }"
            >
              <img
                :src="'http://www.jxdinfo.com' + item.typeImg"
                class="case-img"
              />
              <div class="item-context">
                <div class="item-title">
                  <div class="item-topic">
                    {{ item.title }}
                    <span
                      v-if="item.shortTitle"
                      :style="{
                        color: getColor(item.shortTitle).color,
                        background: getColor(item.shortTitle).background,
                      }"
                      >{{ item.shortTitle }}</span
                    >
                  </div>
                </div>
                <div class="item-text">{{ item.description }}</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- 应用行业 -->
      <div class="applicationIndustry-box">
        <div class="applicationIndustry-title">应用行业</div>
        <div class="applicationIndustry-list">
          <img src="../assets/img/phoneCasePage/application.png" style="width:100%;height:100%" alt="">
        </div>
      </div>
      <!-- 客户心声 -->
      <div class="swipe-box">
        <div class="swipe-title">客户心声</div>
        <div class="swipe-list">
          <van-swipe class="swipe-case" :width="300" :loop="false">
            <!-- <van-swipe-item>
              <div class="swipe-item">
                <img
                  src="../assets/img/phoneHomePage/swipe-1.png"
                  style="width: 100%"
                />
                <div class="title">华中科技公司 余主任</div>
                <div class="text">
                  轻骑兵低代码开发平台统一了公司的技术架构，完善了公司的研发体系，该平台的可视化设计器支持定制各种自定义组件，赋能公司设计团队，助力公司技术积累。
                </div>
              </div>
            </van-swipe-item> -->
            <van-swipe-item>
              <div class="swipe-item">
                <img src="../assets/img/phoneHomePage/swipe-2.png" />
                <div class="title">航天科工集团某研究所 李总</div>
                <div class="text">
                  轻骑兵的可视化设计器很好用，基于平台可以快速进行可视化开发，提升我们的研发效率，平台符合分保要求，支持多版本兼容，这对我们而言是非常重要的两点。
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="swipe-item">
                <img src="../assets/img/phoneHomePage/swipe-3.png" />
                <div class="title">联通河北分公司 赵经理</div>
                <div class="text">
                  轻骑兵低代码开发平台，对业务场景具备快速实现能力，可视化开发模式降低了应用软件的开发难度，开发效率大幅提升。在客户项目中，平台能够快速友好的同其他系统进行整合，实现数据双向交换、共享业务处理流程，同时也减轻了软件维护的负担。
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="swipe-item">
                <img src="../assets/img/phoneHomePage/swipe-4.png" />
                <div class="title">玫德集团 生经理</div>
                <div class="text">
                  轻骑兵低代码开发平台显著降低了企业开发人员数量和水平的要求，能够快速响应客户需求，灵活应用在复杂的开发场景中，降低开发人员的工作量，大幅提高编码效率。
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="swipe-item">
                <img src="../assets/img/phoneHomePage/swipe-5.png" />
                <div class="title">临沂城投思索 丁经理</div>
                <div class="text">
                  轻骑兵低代码开发平台具有可视化低代码开发、开发组件丰富、高安全性等特性，全面适配了国产化环境。我公司采用轻骑兵低代码开发平台大大提升了软件系统开发速度和质量，对降低软件开发成本效果显著。
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="swipe-item">
                <img src="../assets/img/phoneHomePage/swipe-6.png" />
                <div class="title">中泰证券 梁经理</div>
                <div class="text">
                  轻骑兵低代码开发平台统一了后续公司平台的技术框架，各部门的开发成果以组件的形式得到了积累复用，提高了开发效率，极大的减少了不同系统中互联互通的成本，避免了资源的浪费。
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <!-- 更多客户 -->
      <div class="connection-box">
        <div class="connection-title">更多客户</div>
        <div class="connection-list">
          <div class="list-items">
            <el-card class="box-card">
              <img
                class="card-item item1-1"
                src="../assets/img/phoneCasePage/customer1-1.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item1-2"
                src="../assets/img/phoneCasePage/customer1-2.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item1-3"
                src="../assets/img/phoneCasePage/customer1-3.png"
                alt=""
              />
            </el-card>
          </div>
          <div class="list-items">
            <el-card class="box-card">
              <img
                class="card-item item2-1"
                src="../assets/img/phoneCasePage/customer2-1.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item2-2"
                src="../assets/img/phoneCasePage/customer2-2.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item2-3"
                src="../assets/img/phoneCasePage/customer2-3.png"
                alt=""
              />
            </el-card>
          </div>
          <div class="list-items">
            <el-card class="box-card">
              <img
                class="card-item item3-1"
                src="../assets/img/phoneCasePage/customer3-1.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item3-2"
                src="../assets/img/phoneCasePage/customer3-2.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item3-3"
                src="../assets/img/phoneCasePage/customer3-3.png"
                alt=""
              />
            </el-card>
          </div>
          <div class="list-items">
            <el-card class="box-card">
              <img
                class="card-item item4-1"
                src="../assets/img/phoneCasePage/customer4-1.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item4-2"
                src="../assets/img/phoneCasePage/customer4-2.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item4-3"
                src="../assets/img/phoneCasePage/customer4-3.png"
                alt=""
              />
            </el-card>
          </div>
          <div class="list-items">
            <el-card class="box-card">
              <img
                class="card-item item5-1"
                src="../assets/img/phoneCasePage/customer5-1.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item5-2"
                src="../assets/img/phoneCasePage/customer5-2.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item5-3"
                src="../assets/img/phoneCasePage/customer5-3.png"
                alt=""
              />
            </el-card>
          </div>
          <div class="list-items">
            <el-card class="box-card">
              <img
                class="card-item item6-1"
                src="../assets/img/phoneCasePage/customer6-1.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item6-2"
                src="../assets/img/phoneCasePage/customer6-2.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item6-3"
                src="../assets/img/phoneCasePage/customer6-3.png"
                alt=""
              />
            </el-card>
          </div>
          <div class="list-items">
            <el-card class="box-card">
              <img
                class="card-item item7-1"
                src="../assets/img/phoneCasePage/customer7-1.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <img
                class="card-item item7-2"
                src="../assets/img/phoneCasePage/customer7-2.png"
                alt=""
              />
            </el-card>
            <el-card class="box-card">
              <!-- <div class="item7-3">···</div> -->
               <img
                class="card-item item7-3"
                src="../assets/img/phoneCasePage/customer7-3.png"
                alt=""
              />
            </el-card>
          </div>
        </div>
      </div>
      <!-- 公司信息 -->
      <CompanyInformation @changePracticeMenuShow="handleOpenPractice">
      </CompanyInformation>
    </div>
    <!-- 右侧菜单 -->
    <RightMenu
      :isMenuShow="isMenuShow"
      @rightMenuShow="handleRightMenuShow"
    ></RightMenu>
    <!-- 底部立即体验弹出 -->
    <ExperienceNow
      :isPopShow="isPopShow"
      @CloseExperienceNow="handleCloseExperienceNow"
    ></ExperienceNow>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import CompanyInformation from "./include/CompanyInformation.vue";
import RightMenu from "./include/RightMenu.vue";
import ExperienceNow from "./include/ExperienceNow.vue";
import {
  getCustomCase,
} from "../api/casePage.js";
export default {
  name: "HussarHomePhonePage",
  components: {
    PhoneFooter,
    PhoneHeader,
    CompanyInformation,
    RightMenu,
    ExperienceNow,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      article: [],
      articleTotal: 0,
      articlePage: 0,
      articleData: {
        channelId: 287,
        pageNo: 1,
        pageSize: 8,
      },
      // 案例标签颜色
      colorList: [
        {
          name: "航天航空",
          color: "#2682FF",
          background: "#D2E5FF",
        },
        {
          name: "电力",
          color: "#EC9C23",
          background: "#FFE8C5",
        },
        {
          name: "智能制造",
          color: "#374AEC",
          background: "#D1D6FC",
        },
        {
          name: "建筑工程",
          color: "#7909CE",
          background: "#E9D1FC",
        },
        {
          name: "证券金融",
          color: "#BEB101",
          background: "#FFFBC5",
        },
        {
          name: "通信",
          color: "#E93636",
          background: "#FED2D2",
        },
        {
          name: "能源",
          color: "#009F2A",
          background: "#CBF8D7",
        },
        {
          name: "轨道交通",
          color: "#00A2DF",
          background: "#D2F3FF",
        },
        {
          name: "石化",
          color: "#308805",
          background: "#DAF8CB",
        },
        {
          name:'有色金属',
          color:'#7909CE',
          background:'#E9D1FC',
        },
        {
          name:'金属冶炼',
          color:'#EFA83E',
          background:'#FFE8C5',
        },
      ],
    };
  },
  watch: {},
  methods: {
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow(param) {
      this.isPopShow = false;
    },
    getCustomCase() {
      const self = this;
      getCustomCase(self.articleData)
        .then((res) => {
          self.article = res.data.content;
          self.articleTotal = res.data.total;
          self.articlePage =
            Math.trunc(self.articleTotal / self.articleData.pageSize) + 1;
        })
        .catch((error) => {
          self.$message.error("未获取到文章!");
        });
    },
    getColor(name) {
      const self = this;
      let color = "";
      let background = "";
      for (let i = 0; i < self.colorList.length; i++) {
        if (self.colorList[i].name === name) {
          color = self.colorList[i].color;
          background = self.colorList[i].background;
          break;
        }
      }
      return {
        color,
        background,
      };
    },
  },
  mounted() {
    this.getCustomCase();
  },
};
</script>

<style scoped>
.container {
  position: relative;
  top: 53px;
}
.banner-box {
  width: 100%;
  height: 391px;
  background: url("../assets/img/phoneCasePage/header-bg.png");
  background-size: cover;
}
.banner-con {
  width: 100%;
  margin: 0 auto;
  padding-top: 50px;
}
.banner-title {
  font-size: 0.44rem;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  color: #fff;
}
.banner-desc {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 0.26rem;
  font-weight: 500;
  justify-content: center;
  color: #fff;
  line-height: 60px;
}
/*评论*/
/* .customerComments{width:330px;height: 215px;margin: 0 auto;position: relative;} */
.customerComments {
  width: 330px;
  height: 215px;
  margin: 0 auto;
  position: relative;
}
.customerComments img {
  vertical-align: middle;
}
.customerCommentsStyle {
  background: linear-gradient(
    90deg,
    rgba(88, 140, 245, 0.1) 0%,
    rgba(39, 102, 248, 0.85) 100%
  );
  position: absolute;
}
.developmentExperience {
  opacity: 0;
  top: 100px;
  position: absolute;
  left: 130px;
  color: #fff;
  font-size: 0.18rem;
  width: 210px;
  height: 23px;
  border-radius: 17px;
  line-height: 23px;
}
.developmentExperience div {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.developmentExperience img {
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.poc {
  opacity: 0;
  position: absolute;
  top: 100px;
  left: -15px;
  width: 140px;
  height: 25px;
  color: #fff;
  font-size: 0.22rem;
  border-radius: 20px;
  line-height: 25px;
}
.poc div {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.poc img {
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.technicalRoutes {
  opacity: 0;
  position: absolute;
  top: 150px;
  left: 210px;
  width: 130px;
  height: 25px;
  color: #fff;
  font-size: 0.22rem;
  border-radius: 18px;
  line-height: 25px;
}
.technicalRoutes div {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.technicalRoutes img {
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.safe {
  opacity: 0;
  position: absolute;
  top: 140px;
  left: 10px;
  width: 190px;
  height: 25px;
  color: #fff;
  font-size: 0.24rem;
  border-radius: 20px;
  line-height: 25px;
}
.safe div {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.safe img {
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.expansion {
  opacity: 0;
  position: absolute;
  top: 54px;
  left: 75px;
  width: 250px;
  height: 36px;
  color: #fff;
  font-size: 16px;
  border-radius: 18px;
  line-height: 36px;
}
.expansion div {
  width: 210px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.expansion img {
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.service {
  opacity: 0;
  position: absolute;
  top: 60px;
  left: 110px;
  width: 170px;
  height: 25px;
  color: #fff;
  font-size: 0.2rem;
  border-radius: 20px;
  line-height: 25px;
}
.service div {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.service img {
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.reversible {
  opacity: 0;
  position: absolute;
  top: 140px;
  left: 39px;
  width: 150px;
  height: 30px;
  color: #fff;
  font-size: 14px;
  border-radius: 15px;
  line-height: 30px;
}
.reversible div {
  width: 130px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reversible img {
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.costSave {
  opacity: 0;
  position: absolute;
  top: 175px;
  left: -25px;
  width: 150px;
  height: 25px;
  color: #fff;
  font-size: 0.24rem;
  border-radius: 20px;
  line-height: 25px;
}
.costSave div {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.costSave img {
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.nationalInternet {
  opacity: 0;
  position: absolute;
  top: 190px;
  left: 140px;
  width: 180px;
  height: 25px;
  color: #fff;
  font-size: 0.22rem;
  border-radius: 16px;
  line-height: 25px;
}
.nationalInternet div {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nationalInternet img {
  height: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.showOrHide1 {
  animation-name: showOrHide1;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}
@keyframes showOrHide1 {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  74% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.showOrHide2 {
  animation-name: showOrHide2;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}
@keyframes showOrHide2 {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  76% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.showOrHide3 {
  animation-name: showOrHide3;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}
@keyframes showOrHide3 {
  0% {
    opacity: 0;
  }
  30% {
    opacity: 1;
  }
  78% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.showOrHide4 {
  animation-name: showOrHide4;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}
@keyframes showOrHide4 {
  0% {
    opacity: 0;
  }
  37% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.showOrHide5 {
  animation-name: showOrHide5;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}
@keyframes showOrHide5 {
  0% {
    opacity: 0;
  }
  45% {
    opacity: 1;
  }
  82% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.showOrHide6 {
  animation-name: showOrHide6;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}
@keyframes showOrHide6 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  84% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.showOrHide7 {
  animation-name: showOrHide7;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}
@keyframes showOrHide7 {
  0% {
    opacity: 0;
  }
  55% {
    opacity: 1;
  }
  86% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.showOrHide8 {
  animation-name: showOrHide8;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}
@keyframes showOrHide8 {
  0% {
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  88% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.showOrHide9 {
  animation-name: showOrHide9;
  animation-duration: 12s;
  animation-iteration-count: infinite;
}
@keyframes showOrHide9 {
  0% {
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.developmentExperience:hover,
.poc:hover,
.technicalRoutes:hover,
.safe:hover,
.expansion:hover,
.service:hover,
.reversible:hover,
.costSave:hover,
.nationalInternet:hover {
  transform: translate(5px, -5px);
  transition: all 500ms ease;
  border: 1px rgba(75, 206, 255, 1) solid;
  animation-duration: 0s;
  opacity: 1;
}

/* 典型案例 */
.case-box {
  margin: 40px 20px 20px 20px;
}
.case-box .case-title {
  font-size: 0.44rem;
  font-weight: 600;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.case-box .case-list .case-item {
  box-shadow: 0px 0px 10px 1px rgba(0, 65, 178, 0.16);
  border-radius: 5px;
  margin-bottom: 30px;
  padding-bottom: 30px;
}
.case-box .case-list .more {
  display: flex;
  justify-content: center;
}
.case-box .case-list .more .van-button {
  width: 60%;
}
.case-box .case-list .case-item .case-img {
  width: 100%;
}
.case-box .case-list .case-item .item-context {
  padding: 15px;
}
.case-box .case-list .case-item .item-context .item-title {
  display: flex;
  align-items: center;
}
.case-box .case-list .case-item .item-context .item-title .item-topic {
  font-size: 0.32rem;
  font-weight: 600;
  margin-right: 10px;
  color: #000;
}
.case-box .case-list .case-item .item-context .item-title .item-topic span {
  font-size: 0.22rem;
  font-weight: 0 !important;
  font-size: 13px;
  padding: 2px 7px;
  border-radius: 5px;
}
.case-box .case-list .case-item .item-context .item-title .item-label {
  height: 22px;
}
.case-box .case-list .case-item .item-context .item-text {
  margin-top: 10px;
  font-size: 0.26rem;
  line-height: 22px;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #000;
}
.case-box .case-list .case-item .item-context .item-logo {
  height: 50px;
  margin-top: 10px;
}
/* 应用行业 */
.applicationIndustry-box {
  padding-top: 20px;
}
.applicationIndustry-title {
  display: flex;
  justify-content: center;
  font-size: 0.44rem;
  font-weight: 600;
}
.applicationIndustry-list {
  display: flex;
  justify-content: space-between;
  padding: 40px 0px;
}

/* 客户心声 */
.swipe-box {
  height: 500px;
  background-image: linear-gradient(#125ee0, #7aaafd);
  padding: 20px;
}
.swipe-title {
  display: flex;
  justify-content: center;
  font-size: 0.44rem;
  color: #fff;
  font-weight: 600;
}

.swipe-list {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.swipe-case {
  height: 370px;
}
.swipe-case >>> .van-swipe__indicators .van-swipe__indicator {
  background: #333333;
}
.swipe-case >>> .van-swipe__indicator--active {
  background-color: #1989fa !important;
}
.swipe-item {
  height: 100%;
  width: 90%;
  padding: 20px 20px 0 20px;
  background-image: linear-gradient(to bottom, #fff, #e9f0ff);
  border-radius: 5px;
}
.van-swipe-item {
  display: flex;
  justify-content: center;
}
.swipe-item > img {
  height: 55px;
}
.swipe-item > .title {
  margin: 10px 0;
  font-size: 18px;
  font-weight: 600;
}
.swipe-item > .text {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

/* 更多客户 */
.connection-box {
  margin: 40px 0 40px 0;
}
.connection-title {
  display: flex;
  justify-content: center;
  font-size: 0.44rem;
  color: #000;
  font-weight: 600;
  padding-bottom: 10px;
}
.connection-list {
  width: 100%;
}
.connection-list .list-items {
  display: flex;
  margin: 20px 10px 10px 10px;
}
.connection-list .list-items .box-card {
  margin-right: 10px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.connection-list .list-items .box-card:last-child {
  margin-right: 0;
}

.box-card {
  width: 33%;
  display: flex;
}
/deep/ .box-card .el-card__body {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-card .card-item {
  width: 100%;
}
.item1-1 {
  width: 90% !important;
}
.item1-2 {
  width: 75% !important;
}
.item1-3 {
  width: 50% !important;
}
.item2-1 {
  width: 70% !important;
}
.item2-2 {
  width: 110% !important;
}
.item2-3 {
  width: 90% !important;
}
.item3-1 {
  width: 90% !important;
}
.item3-2 {
  width: 70% !important;
}
.item3-3 {
  width: 90% !important;
}
.item4-1 {
  width: 60% !important;
}
.item4-2 {
  width: 80% !important;
}
.item4-3 {
  width: 90% !important;
}

.item5-1 {
  width: 80% !important;
}
.item5-2 {
  width: 90% !important;
}
.item5-3 {
  width: 50% !important;
}
.item6-1 {
  width: 70% !important;
}
.item6-2 {
  width: 50% !important;
}
.item6-3 {
  width: 70% !important;
}
.item7-1 {
  width: 90% !important;
}
.item7-2 {
  width: 80% !important;
}
.card-item.item7-3 {
  width: 90%;
}

</style>



// WEBPACK FOOTER //
// src/components/CasePhonePage.vue